const timeToClimbFeatureFlags = {
	aprilFoolsSkin: 'time-to-climb-april-fools-skin',
	halloweenSkin: 'time-to-climb-halloween-skin',
	holidaySkin: 'time-to-climb-holiday-skin',
	underwaterSkin: 'time-to-climb-underwater-skin',
	valentinesSkin: 'time-to-climb-valentines-skin',
	teacherDisableTTCTimer: 'teacher-disable-ttc-timer',
}

const getTTCFeatureFlags = (featureFlags: any): any => {
	const result: Record<string, any> = {}
	for (const [key, value] of Object.entries(timeToClimbFeatureFlags)) {
		result[key] = featureFlags[value]
	}
	return result
}

export default getTTCFeatureFlags
